import Vue from 'vue';
import Router from 'vue-router';
import ErrorPage from '@/components/ErrorPage';
import MeetingsList from '@/components/MeetingsList';
import MeetingDashboard from '@/components/MeetingDashboard';
import MeetingSettings from '@/components/meeting/MeetingSettings';
import AttendeeDashboard from '@/components/AttendeeDashboard';
import AppointmentTimes from '@/components/meeting/AppointmentTimes';
import ManageRetailers from '@/components/meeting/ManageRetailers';
import ManageSuppliers from '@/components/meeting/ManageSuppliers';
import ManageServiceProviders from '@/components/meeting/ManageServiceProviders';
import ViewFullSchedule from '@/components/meeting/ViewFullSchedule';
import PrintableSchedules from '@/components/meeting/PrintableSchedules';
import SummaryReportBuilder from '@/components/meeting/SummaryReportBuilder';
import Schedule from '@/components/attendees/Schedule';
import ViewExhibitors from '@/components/attendees/ViewExhibitors';
import ExhibitorSchedule from '@/components/shared/ExhibitorSchedule';
import UserSuites from '@/components/attendees/UserSuites';
import auth from '../services/auth';

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      redirect: '/meetings'
    },
    {
      path: '/meetings',
      name: 'MeetingsList',
      component: MeetingsList,
      meta: {
        requiresAdmin: false,
        requiresAuth: true
      }
    },
    {
      path: '/meetings/:id/admin',
      component: MeetingDashboard,
      props: true,
      meta: {
        requiresAdmin: true,
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'MeetingDashboard',
          component: AppointmentTimes
        },
        {
          path: 'settings',
          name: 'MeetingSettings',
          component: MeetingSettings
        },
        {
          path: 'retailers',
          name: 'ManageRetailers',
          component: ManageRetailers
        },
        {
          path: 'suppliers',
          name: 'ManageSuppliers',
          component: ManageSuppliers
        },
        {
          path: 'serviceProviders',
          name: 'ManageServiceProviders',
          component: ManageServiceProviders
        },
        {
          path: 'viewFullSchedule',
          name: 'ViewFullSchedule',
          component: ViewFullSchedule,
          props: true
        },
        {
          path: 'printableSchedules',
          name: 'PrintableSchedules',
          component: PrintableSchedules,
          props: true
        },
        {
          path: 'view/:suiteId',
          name: 'AdminViewSchedule',
          component: Schedule,
          props: true
        },
        {
          path: 'summaryReport',
          name: 'SummaryReportBuilder',
          component: SummaryReportBuilder
        }
      ]
    },
    {
      path: '/meetings/:id',
      component: AttendeeDashboard,
      props: true,
      meta: {
        requiresAdmin: false,
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'UserSuites',
          component: UserSuites,
          props: true
        },
        {
          path: 'exhibitors',
          name: 'ViewExhibitors',
          component: ViewExhibitors,
          props: true
        },
        {
          path: 'schedule/:suiteId',
          name: 'ExhibitorSchedule',
          component: ExhibitorSchedule,
          props: true
        }
      ]
    },
    {
      path: '/error',
      name: 'ErrorPage',
      component: ErrorPage
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  // if (to.name !== 'ErrorView') {
  //   let mismatchError = new Error('Server does not match client')
  //   mismatchError.name = 'ServerMismatch'
  //   next(mismatchError)
  //   return
  // }
  if (to.path === '/receiveToken') {
    if (to.query.hasOwnProperty('jwt')) {
      const redirectTo = localStorage.getItem('appPath') || '';
      return auth.authenticateFirebase(to.query.jwt).then(() => {
        next({
          path: redirectTo,
          replace: true
        });
      });
    } else {
      return next({
        path: '/error',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!auth.loggedIn()) {
        auth.fetchJWT(to);
      } else {
        return next();
      }
    }
    if (to.matched.some(record => record.meta.requiresAdmin)) {
      // this route requires admin, check if is admin
      // if not, show access denied page
      if (!auth.isAdmin()) {
        return next({
          path: '/error',
          // WIP: props not working currently. haven't figured out why.
          props: {
            errorMessage: 'Access to this page is restricted.'
          },
          query: { redirect: to.fullPath }
        });
      } else {
        return next();
      }
    }
    return next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js